module.exports = __webpack_public_path__ + "img/logo.7cfa3d55.png";